var _defs, _path, _path2, _path3, _path4, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommercialVehiclescopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.55 448.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#f26725;stroke-linecap:round;stroke-linejoin:round;stroke-width:8.45px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m198.46,166.11l69.57-69.57c7.1-7.1,18.6-7.1,25.7,0l57.85,57.85c7.1,7.1,7.1,18.6,0,25.7l-69.57,69.57c-20.47,20.47-53.66,20.47-74.13,0l-9.42-9.42c-20.47-20.47-20.47-53.66,0-74.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m188.32,225.97l-100.72,100.7c-1.46,1.46-2.45,3.35-2.85,5.39l-6.26,28.52,9.9,9.9,27.67-7.11c2.05-.39,3.93-1.39,5.39-2.85l8.53-8.53,2.47-20.26,18.1-.31,6.78-6.78,3.53-15.41,16.13-4.25,4.57-4.57-.33-12.44,8.52-8.52,11.4,1.37,9.74-9.74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m299.67,86.24l1.78-1.78c8.51-8.51,22.37-8.51,30.88,0l31.33,31.33c8.51,8.51,8.51,22.37,0,30.88l-1.78,1.78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m238.14,133.04h57.65c4.37,0,7.92,3.55,7.92,7.92v82.19c0,3.39-2.75,6.14-6.14,6.14h-61.22c-3.39,0-6.14-2.75-6.14-6.14v-82.18c0-4.37,3.55-7.92,7.92-7.92Z",
    transform: "translate(327.63 498.03) rotate(-135)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 240.98,
    y1: 155.17,
    x2: 292.95,
    y2: 207.15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 275.09,
    y1: 154.4,
    x2: 293.73,
    y2: 173.03
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 240.2,
    y1: 189.29,
    x2: 258.83,
    y2: 207.92
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialVehiclescopy2);
export default __webpack_public_path__ + "static/media/Commercial Vehicles copy 2.f9a6296ba59f3ed6b3f64b2d792d5cde.svg";
export { ForwardRef as ReactComponent };